export enum ADPPersonEnum {
    Applicant = 1,
    Agent = 2
}
